export default __webpack_public_path__ + "static/media/bookings.414bcfa3.svg";